import { createContext, useContext, useState } from "react";

const TOKEN_KEY = "token";
const ADMIN_KEY = "bixjet_admin";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || null);
  const [admin, setAdmin] = useState(() => {
    try { return JSON.parse(localStorage.getItem(ADMIN_KEY) || "null"); } catch { return null; }
  });

  const login = (tok, adminData) => {
    setToken(tok);
    setAdmin(adminData);
    localStorage.setItem(TOKEN_KEY, tok);
    localStorage.setItem(ADMIN_KEY, JSON.stringify(adminData));
  };

  const logout = () => {
    setToken(null);
    setAdmin(null);
    localStorage.clear();
  };

  return (
    <AuthContext.Provider value={{ token, admin, login, logout, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
